<template>
  <div class="container-fluid m-0 p-0" v-if="user">
    <div class="row">
      <div class="col-12">
        <div class="card my-4">
          <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
            <div
              class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3 d-flex justify-content-between align-items-center"
            >
              <h6 class="text-white text-capitalize ps-3 mb-0">Histórico de clientes</h6>
              <div class="me-3">
                <DefaultButton
                  :label="'Exportar'"
                  :buttonColor="campaignSelected ? '#ffffff' : '#cccccc'"
                  :textColor="campaignSelected ? '#661cb0' : '#999999'"
                  :disabled="!campaignSelected"
                  @click="toggleExportMenu"
                  class="export-button"
                />
                <PrimeMenu
                  ref="exportMenu"
                  :model="exportMenuItems"
                  :popup="true"
                  class="export-menu"
                />
              </div>
            </div>
          </div>

          <div class="card-body p-4">
            <v-container>
              <v-row>
                <v-col v-if="user.role == 'ADMIN'">
                  <label class="input-label w-100">
                    <span
                      class="text-xs text-uppercase text-body font-weight-bolder"
                    >
                      Selecione um usuário
                    </span>
                    <div class="d-flex align-items-center position-relative">
                      <AutoComplete
                        v-model="userSelected"
                        dropdown
                        optionLabel="full_name"
                        @complete="searchUsers"
                        @option-select="handleUser"
                        @clear="handleClear"
                        :suggestions="filteredUsers"
                        placeholder="Selecione..."
                        class="bordered-autocomplete"
                        emptySearchMessage="Nenhum usuário encontrado"
                      />
                    </div>
                  </label>

                  <DefaultSelect
                    v-if="userSelected"
                    label="Selecione uma campanha"
                    :options="raffles"
                    itemText="name"
                    itemValue="id"
                    @change="handleCampaign"
                    placeholder="Selecione..."
                    v-model="campaignSelected"
                  />
                </v-col>
                <div v-if="user.role == 'USER'" class="campaign-select">
                  <DefaultSelect
                    label="Selecione uma campanha"
                    :options="raffles"
                    itemText="name"
                    itemValue="id"
                    @change="handleCampaign"
                    placeholder="Selecione..."
                    v-model="campaignSelected"
                  />

                  <DefaultButton
                    v-if="campaignSelected"
                    :label="'Atualizar lista'"
                    :buttonColor="'#661cb0'"
                    :textColor="'#ffffff'"
                    @confirm="handleUpdateList(campaignSelected)"
                    class="refresh-button"
                  />
                </div>
              </v-row>
            </v-container>

            <DefaultSelect
              v-if="campaignSelected"
              label="Status da reserva"
              :options="[
                { name: 'Sem filtro', value: 'NO_FILTER' },
                { name: 'Pendente', value: 'WAITING' },
                { name: 'Pago', value: 'APPROVED' },
                { name: 'Expirado', value: 'EXPIRED' },
              ]"
              itemText="name"
              itemValue="value"
              @change="handleFilter"
              placeholder="Selecione..."
              v-model="status"
            />

            <DefaultSelect
              v-if="campaignSelected"
              label="Filtro da Data"
              :options="[
                { name: 'Sem filtro', value: 'false' },
                { name: 'Hoje', value: 'true' },
              ]"
              itemText="name"
              itemValue="value"
              @change="handleFilter"
              placeholder="Selecione..."
              v-model="today"
            />

            <DefaultSelect
              v-if="campaignSelected"
              label="Tipo do filtro textual"
              :options="[
                { name: 'Sem filtro', value: 'NO_FILTER' },
                { name: 'Nome do comprador', value: 'name' },
                { name: 'Telefone', value: 'phone' },
                { name: 'Cota', value: 'quota' },
              ]"
              itemText="name"
              itemValue="value"
              @change="handleFilter"
              placeholder="Selecione..."
              v-model="filter"
            />

            <div
              style="display: flex; align-items: end; gap: 15px"
              v-if="campaignSelected && filter != 'NO_FILTER'"
            >
              <DefaultInput
                class="mb-0"
                v-model="search"
                label="Pesquisa"
                placeholder="Insira o texto da pesquisa"
              />

              <DefaultButton
                :label="'Buscar'"
                :buttonColor="'#661cb0'"
                :textColor="'#ffffff'"
                :spinnerBgColor="'#ffffff'"
                :spinnerColor="'#37016e'"
                style="margin-bottom: 0.5rem; width: 100px"
                @confirm="getOrders(campaignSelected)"
              />
            </div>

            <template v-if="campaignSelected">
              <div class="card-body px-0 pt-4">
                <div
                  class="order-card mb-3 p-3 shadow-sm rounded"
                  v-for="(o, index) in orders"
                  :key="o.id"
                >
                  <div class="order-header">
                    <div class="order-header-title">
                      <h5 class="order-name mb-0">{{ o.name }}</h5>
                      <span
                        class="badge"
                        :class="{
                          'badge-green': o.payment_status === 'APPROVED',
                          'badge-orange': o.payment_status === 'WAITING',
                          'badge-red': o.payment_status === 'EXPIRED',
                          'badge-gray': o.payment_status === 'CANCELED',
                        }"
                      >
                        {{ getPaymentStatusText(o.payment_status) }}
                      </span>
                      <span
                        v-if="o.charge_id == 'PGTO-MANUAL'"
                        class="badge badge-green"
                        style="background-color: #661cb0; color: #ffffff; border: 1px solid #661cb0"
                      >
                        MARCADO MANUALMENTE
                      </span>
                      <span
                        v-if="o.payment_provider == 'SYSTEM' && o.charge_id != 'PGTO-MANUAL'"
                        class="badge badge-green"
                        style="background-color: #661cb0; color: #ffffff; border: 1px solid #661cb0"
                      >
                        RECEBIDO VIA CARTEIRA DO SISTEMA
                      </span>
                      <span
                        v-if="o.payment_provider != 'SYSTEM' && o.charge_id != 'PGTO-MANUAL'"
                        class="badge badge-green"
                        style="background-color: #661cb0; color: #ffffff; border: 1px solid #661cb0"
                      >
                        RECEBIDO VIA {{ o.payment_provider }}
                      </span>
                    </div>

                    <button class="more-btn" @click="toggle(index, $event)">
                      <i class="material-icons">more_vert</i>
                    </button>
                    <PrimeMenu
                      :ref="(el) => setMenuRef(el, index)"
                      :id="`overlay_menu_${index}`"
                      :model="getMenuItems(o)"
                      :popup="true"
                    />
                  </div>

                  <div class="order-body mt-3">
                    <div class="order-info">
                      <span>
                        <strong>Telefone: </strong>
                        {{ getTelephone(o.phone) }}
                      </span>
                      <span v-if="o.email && o.email.trim() !== ''">
                        <strong>E-mail: </strong>
                        {{ o.email }}
                      </span>
                      <span>
                        <strong>Valor: </strong>
                        {{
                          o.value.toLocaleString("pt-br", {
                            style: "currency",
                            currency: "BRL",
                          })
                        }}
                      </span>
                      <span>
                        <strong>Quantidade de cotas: </strong>
                        {{ o.qnt_quotas }}
                      </span>
                      <span>
                        <strong>Taxa: </strong>
                        {{
                          o.fee.toLocaleString("pt-br", {
                            style: "currency",
                            currency: "BRL",
                          })
                        }}
                      </span>
                      <span>
                        <strong>Criado em: </strong>
                        {{ new Date(o.created_at).toLocaleDateString() }},
                        {{ new Date(o.created_at).toLocaleTimeString() }}
                      </span>
                    </div>
                    <div
                      class="order-quotas mt-2"
                      v-if="o.quotas && o.quotas.trim() !== ''"
                    >
                      <span
                        class="quota-badge badge-green mr-1"
                        v-for="(q, index) in parseAndSortQuotas(o.quotas)"
                        :key="index"
                      >
                        {{ formatQuota(q) }}
                      </span>
                    </div>
                  </div>
                </div>

                <Paginator
                  v-if="pages > 1"
                  v-model:first="currentPage"
                  :rows="1"
                  :totalRecords="pages"
                  @page="onPageChange"
                />
              </div>
            </template>

            <template v-else>
              <div class="no-data-message">
                <p>Selecione uma campanha para accesar o histórico.</p>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <Loading v-if="loading" />
    <ConfirmDialog />
  </div>
</template>

<script>
import UsersHttp from "@/http/UsersHttp.js";
import ParticipantsHttp from "@/http/ParticipantsHttp.js";
import Loading from "@/components/Loading.vue";
import DefaultSelect from "@/components/DefaultSelect.vue";
import DefaultInput from "@/components/DefaultInput.vue";
import DefaultButton from "@/components/DefaultButton.vue";
import PrimeMenu from "primevue/menu";
import RafflesHttp from "/src/http/RafflesHttp.js";
import { AutoComplete, Paginator } from "primevue";
import ConfirmDialog from "primevue/confirmdialog";
import LoggingMixin from "@/mixins/LoggingMixin";
import { getTelephone } from "@/helpers/phoneNumber.js";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";

export default {
  name: "orders",
  mixins: [LoggingMixin],
  components: {
    Loading,
    DefaultSelect,
    DefaultInput,
    DefaultButton,
    PrimeMenu,
    Paginator,
    AutoComplete,
    ConfirmDialog,
  },
  data() {
    return {
      user: null,
      userSelected: null,
      campaignSelected: "",
      raffles: [],
      items: [],
      orders: [],
      search: "",
      status: "NO_FILTER",
      filter: "NO_FILTER",
      today: "false",
      pages: 0,
      currentPage: 0,
      loading: true,
      raffleObject: {},
      users: null,
      filteredUsers: [],
      menuRefs: [],
      exportMenuItems: [
        {
          label: "PDF",
          command: () => this.exportData("pdf"),
        },
        {
          label: "Excel",
          command: () => this.exportData("excel"),
        },
        {
          label: "CSV",
          command: () => this.exportData("csv"),
        },
      ],
    };
  },
  async mounted() {
    this.user = this.$store.getters.user;
    await this.init();
    await this.checkQueryParams();
  },
  watch: {
    "$store.state.isDarkMode": function () {
      if (this.$store.state.isDarkMode) {
        document.querySelectorAll(".input-default").forEach((el) => {
          el.classList.add("dark-mode-input");
        });
      } else {
        document.querySelectorAll(".input-default").forEach((el) => {
          el.classList.remove("dark-mode-input");
        });
      }
    },
  },
  methods: {
    getTelephone,
    async init() {
      this.loading = true;
      await this.verifyDarkMode();
      if (this.user.role === "ADMIN") {
        await this.getUsers();
      }

      if (this.user.role === "USER") {
        await this.getRaffles();
      }
      this.loading = false;
    },
    async getUsers() {
      try {
        const response = await UsersHttp.getUsersMinimum();
        this.users = response.data;
      } catch (error) {
        console.error(error);
      }
    },
    async handleUser(e) {
      let id_user = e.value;
      this.ranking = [];
      this.orders = [];
      this.campaignSelected = "";

      this.userSelected = id_user;
      await this.getRafflesByUserId(id_user.id);
    },
    async getRafflesByUserId(id, showLoading = true) {
      try {
        if (showLoading) {
          this.$swal.fire({
            title: "Aguarde...",
            allowOutsideClick: false,
            onBeforeOpen: () => {
              this.$swal.showLoading();
            },
          });
        }

        const response = await RafflesHttp.getRafflesByUser(id);
        this.raffles = response.data;

        if (showLoading) {
          this.$swal.close();
        }
      } catch (error) {
        console.error(error);
        if (showLoading && this.$swal.isVisible()) {
          this.$swal.close();
        }
      }
    },
    async verifyDarkMode() {
      if (this.$store.state.isDarkMode) {
        document.querySelectorAll(".input-default").forEach((el) => {
          el.classList.add("dark-mode-input");
        });
      } else {
        document.querySelectorAll(".input-default").forEach((el) => {
          el.classList.remove("dark-mode-input");
        });
      }
    },
    handleOptions(id) {
      let actual = document.querySelector(`.options-list-${id}`).style.display
        ? document.querySelector(`.options-list-${id}`).style.display
        : "none";

      document.querySelectorAll(".options-list").forEach((el) => {
        el.style.display = "none";
      });

      if (actual == "none") {
        document.querySelector(`.options-list-${id}`).style.display = "block";
      } else {
        document.querySelector(`.options-list-${id}`).style.display = "none";
      }
    },
    async getRaffles() {
      try {
        const response = await RafflesHttp.getRafflesMinimum();
        this.raffles = response.data;
      } catch (error) {
        console.error(error);
      }
    },
    async handleUpdateList(campaignSelected) {
      this.currentPage = 0;
      await this.getOrders(campaignSelected, this.currentPage);
    },
    async getOrders(idCampaign, page) {
      this.loading = true;

      try {
        const parsebool = (str) => {
          if (str == "true") {
            return true;
          } else {
            return false;
          }
        };
        let body = {
          today: parsebool(this.today),
          search: this.search,
          status: this.status,
          filter: this.filter,
        };

        if (body.filter == "NO_FILTER") {
          body.filter = "";
        }

        if (body.status == "NO_FILTER") {
          body.status = "";
        }

        const response = await ParticipantsHttp.getOrders(
          idCampaign,
          page || 1,
          body
        );
        this.orders = response.data.data;
        this.pages = response.data.pages;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async onPageChange(event) {
      const page = event.page + 1;
      await this.getOrders(this.campaignSelected, page);
    },
    async handleCampaign(e) {
      this.ranking = [];
      this.pages = 0;
      this.loading = true;

      this.today = "false";
      this.status = "NO_FILTER";
      this.filter = "NO_FILTER";
      this.search = "";

      await this.getOrders(e.target.value);

      try {
        const slug = this.raffles.find((item) => item.id == e.target.value);
        if (slug) {
          this.loading = true;
          this.$log.logOrdersViewed(slug.name);
          const response = await RafflesHttp.getRaffle(slug.slug);
          this.raffleObject = response.data;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }

      this.campaignSelected = e.target.value;
    },

    async handleFilter() {
      this.loading = true;
      await this.getOrders(this.campaignSelected);
      this.loading = false;
    },
    async markAsPaid(d) {
      this.loading = true;
      try {
        await ParticipantsHttp.markAsPaid(d.id);
        const campaignName = this.raffles.find((r) => r.id == this.campaignSelected)?.name || `ID ${this.campaignSelected}`;
        this.$log.logMarkedAsPaid(d.name, campaignName);
        await this.getOrders(this.campaignSelected);
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
    toggle(index, event) {
      const menu = this.menuRefs[index];
      if (menu) menu.toggle(event);
    },
    // getWhatsAppUrl(telefone, mensagem) {
    //   const baseURL = "https://wa.me/";
    //   const mensagemCodificada = encodeURIComponent(mensagem);
    //   return `${baseURL}${telefone}?text=${mensagemCodificada}`;
    // },
    getWhatsAppUrl(telefone) {
      const baseURL = "https://wa.me/";
      return `${baseURL}${telefone}`;
    },
    sendWhatsAppMessage(o) {
      const phone = o.phone;
      const cleanedPhone = phone.replace(/[\s()-]/g, "");
      const link = this.getWhatsAppUrl(`55${cleanedPhone}`);
      window.open(link, "_blank").focus();
    },
    async cancelOrder(o) {
      try {
        await ParticipantsHttp.cancelOrder(o.id_campaing, o.id);
        const campaignName = this.raffles.find((r) => r.id == this.campaignSelected)?.name || `ID ${this.campaignSelected}`;
        this.$log.logOrderCanceled(o.name, campaignName);
        this.$toast.add({
          severity: "success",
          summary: "Sucesso!",
          detail: "Pedido cancelado.",
          life: 3000,
        });
        await this.getOrders(this.campaignSelected);
      } catch (error) {
        console.error(error);
        this.$toast.add({
          severity: "error",
          summary: "Houve um erro!",
          detail: "Verifique as informações do pedido e tente novament.",
          life: 3000,
        });
      }
    },
    getPaymentStatusText(status) {
      switch (status) {
        case "APPROVED":
          return "Pago";
        case "WAITING":
          return "Pendente";
        case "CANCELED":
          return "Cancelado";
        default:
          return "Expirado";
      }
    },
    formatQuota(quota) {
      const totalDigits = String(this.raffleObject.qnt_quotas - 1).length;
      return String(quota).padStart(totalDigits, "0");
    },
    parseAndSortQuotas(quotas) {
      if (!quotas || typeof quotas !== "string" || quotas.trim() === "") return [];
      try {
        const parsed = JSON.parse(quotas);
        if (Array.isArray(parsed)) {
          return [...parsed].sort((a, b) => Number(a) - Number(b));
        }
        return [];
      } catch {
        return [];
      }
    },
    searchUsers(e) {
      this.filteredUsers = this.users.filter((country) => {
        return country.full_name
          .toLowerCase()
          .startsWith(e.query.toLowerCase());
      });
    },
    async handleClear() {
      this.userSelected = null;
      this.campaignSelected = "";
      this.raffles = [];
      this.orders = [];
      this.search = "";
      this.status = "NO_FILTER";
      this.filter = "NO_FILTER";
      this.today = "false";
      this.pages = 0;
      this.currentPage = 0;
      this.raffleObject = {};

      this.init();
    },
    async checkQueryParams() {
      const userId = this.$route.query.user;
      const campaignId = this.$route.query.campaign;

      if (!campaignId) return;

      try {
        if (this.user.role === "ADMIN" && userId) {
          // ADMIN: buscar usuário e suas campanhas
          const user = this.users?.find((u) => u.id == userId);
          if (user) {
            this.userSelected = user;

            // Buscar as campanhas do usuário e aguardar o retorno (sem loading modal)
            await this.getRafflesByUserId(userId, false);

            // Agora que temos as campanhas, selecionar a campanha específica
            const campaign = this.raffles.find((r) => r.id == campaignId);
            if (campaign) {
              this.campaignSelected = campaignId;

              // Resetar filtros
              this.today = "false";
              this.status = "NO_FILTER";
              this.filter = "NO_FILTER";
              this.search = "";

              // Buscar os pedidos da campanha
              await this.getOrders(campaignId);

              // Carregar objeto da campanha para formatação das cotas
              const slug = this.raffles.find((item) => item.id == campaignId);
              if (slug) {
                const response = await RafflesHttp.getRaffle(slug.slug);
                this.raffleObject = response.data;
              }
            }
          }
        } else if (this.user.role === "USER") {
          // USER: buscar direto a campanha dele
          const campaign = this.raffles.find((r) => r.id == campaignId);
          if (campaign) {
            this.campaignSelected = campaignId;

            // Resetar filtros
            this.today = "false";
            this.status = "NO_FILTER";
            this.filter = "NO_FILTER";
            this.search = "";

            // Buscar os pedidos da campanha
            await this.getOrders(campaignId);

            // Carregar objeto da campanha para formatação das cotas
            const slug = this.raffles.find((item) => item.id == campaignId);
            if (slug) {
              const response = await RafflesHttp.getRaffle(slug.slug);
              this.raffleObject = response.data;
            }
          }
        }
      } catch (error) {
        console.error("Erro ao processar query params:", error);
      }
    },
    setMenuRef(el, index) {
      if (el) {
        this.menuRefs[index] = el;
      }
    },
    getMenuItems(r) {
      const items = [];

      if (r.payment_status === "WAITING") {
        items.push({
          label: "Marcar como pago",
          command: () => {
            this.markAsPaid(r);
          },
        });
      }

      items.push({
        label: "Entrar em contato",
        command: () => {
          this.sendWhatsAppMessage(r);
        },
      });

      if (r.payment_status === "WAITING" || r.payment_status === "APPROVED") {
        items.push({
          label: "Cancelar reserva",
          command: () => {
            this.$confirm.require({
              message:
                "Você tem certeza que deseja cancelar este pedido? Esta ação não pode ser desfeita.",
              header: "Cancelar pedido",
              rejectProps: {
                label: "Voltar",
                severity: "secondary",
                outlined: true,
              },
              acceptProps: {
                label: "Confirmar",
                severity: "danger",
              },
              accept: () => {
                this.cancelOrder(r);
              },
            });
          },
        });
      }

      return items;
    },
    toggleExportMenu(event) {
      if (this.campaignSelected) {
        this.$refs.exportMenu.toggle(event);
      }
    },
    async exportData(format) {
      if (!this.campaignSelected) return;

      this.loading = true;

      try {
        // Buscar todos os dados sem paginação
        const parsebool = (str) => {
          if (str == "true") {
            return true;
          } else {
            return false;
          }
        };

        let body = {
          today: parsebool(this.today),
          search: this.search,
          status: this.status,
          filter: this.filter,
        };

        if (body.filter == "NO_FILTER") {
          body.filter = "";
        }

        if (body.status == "NO_FILTER") {
          body.status = "";
        }

        const response = await ParticipantsHttp.exportOrders(
          this.campaignSelected,
          body
        );

        const data = response.data.data;

        const campaignName = this.raffles.find((r) => r.id == this.campaignSelected)?.name || `ID ${this.campaignSelected}`;
        if (format === "pdf") {
          await this.exportToPDF(data);
        } else if (format === "excel") {
          await this.exportToExcel(data);
        } else if (format === "csv") {
          await this.exportToCSV(data);
        }
        this.$log.logOrdersExported(campaignName, format);
      } catch (error) {
        console.error("Erro ao exportar dados:", error);
        this.$toast.add({
          severity: "error",
          summary: "Erro!",
          detail: "Erro ao exportar os dados. Tente novamente.",
          life: 3000,
        });
      } finally {
        this.loading = false;
      }
    },
    async exportToPDF(data) {
      try {
        // Usar a importação estática do jsPDF
        const doc = new jsPDF();

        // Título
        doc.setFontSize(16);
        doc.text("Histórico de Pedidos", 14, 22);

        // Informações da campanha
        const campaignName =
          this.raffles.find((r) => r.id == this.campaignSelected)?.name ||
          "Campanha não encontrada";
        doc.setFontSize(12);
        doc.text(`Campanha: ${campaignName}`, 14, 32);
        doc.text(
          `Data de exportação: ${new Date().toLocaleDateString("pt-BR")}`,
          14,
          40
        );

        // Preparar dados para a tabela
        const tableData = data.map((order) => [
          order.name,
          getTelephone(order.phone),
          order.email || "N/A",
          order.value.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          }),
          order.qnt_quotas,
          order.fee.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          }),
          this.getPaymentStatusText(order.payment_status),
          new Date(order.created_at).toLocaleDateString("pt-BR"),
        ]);

        // Cabeçalhos da tabela
        const headers = [
          "Nome",
          "Telefone",
          "E-mail",
          "Valor",
          "Qtd Cotas",
          "Taxa",
          "Status",
          "Data",
        ];

        // Gerar tabela usando autoTable ou fallback
        if (doc.autoTable) {
          doc.autoTable({
            head: [headers],
            body: tableData,
            startY: 50,
            styles: {
              fontSize: 7,
              cellPadding: 1,
              overflow: "linebreak",
              halign: "left",
            },
            headStyles: {
              fillColor: [102, 28, 176],
              textColor: 255,
              fontSize: 8,
              fontStyle: "bold",
            },
            columnStyles: {
              0: { cellWidth: 32 }, // Nome
              1: { cellWidth: 32 }, // Telefone
              2: { cellWidth: 38 }, // E-mail
              3: { cellWidth: 20 }, // Valor
              4: { cellWidth: 16 }, // Qtd Cotas
              5: { cellWidth: 20 }, // Taxa
              6: { cellWidth: 20 }, // Status
              7: { cellWidth: 22 }, // Data
            },
            margin: { top: 50, left: 10, right: 10 },
            theme: "grid",
          });
        } else {
          // Fallback: criar tabela manualmente com melhor formatação
          doc.setFontSize(8);
          let yPos = 55;

          // Definir larguras das colunas
          const colWidths = [32, 32, 38, 20, 16, 20, 20, 22];
          let xPos = 10;

          // Cabeçalhos
          doc.setFont(undefined, "bold");
          headers.forEach((header, index) => {
            doc.text(header, xPos, yPos);
            xPos += colWidths[index];
          });

          yPos += 8;
          doc.setFont(undefined, "normal");

          // Dados
          tableData.forEach((row) => {
            if (yPos > 270) {
              // Nova página se necessário
              doc.addPage();
              yPos = 20;
            }

            xPos = 10;
            row.forEach((cell, colIndex) => {
              let cellText = String(cell);

              // Ajustar texto baseado na coluna
              if (colIndex === 0) cellText = cellText.substring(0, 20); // Nome
              else if (colIndex === 1)
                cellText = cellText.substring(0, 18); // Telefone
              else if (colIndex === 2)
                cellText = cellText.substring(0, 22); // Email
              else if (colIndex === 3)
                cellText = cellText.substring(0, 12); // Valor
              else if (colIndex === 4)
                cellText = cellText.substring(0, 5); // Qtd
              else if (colIndex === 5)
                cellText = cellText.substring(0, 12); // Taxa
              else if (colIndex === 6)
                cellText = cellText.substring(0, 10); // Status
              else if (colIndex === 7) cellText = cellText.substring(0, 12); // Data

              doc.text(cellText, xPos, yPos);
              xPos += colWidths[colIndex];
            });

            yPos += 6;
          });
        }

        // Salvar arquivo
        const fileName = `historico_pedidos_${campaignName.replace(
          /[^a-zA-Z0-9]/g,
          "_"
        )}_${new Date().toISOString().split("T")[0]}.pdf`;
        doc.save(fileName);
      } catch (error) {
        console.error("Erro ao gerar PDF:", error);
        throw error;
      }
    },
    async exportToExcel(data) {
      // Usar a importação estática do XLSX

      // Preparar dados para o Excel
      const excelData = data.map((order) => ({
        Nome: order.name,
        Telefone: getTelephone(order.phone),
        "E-mail": order.email || "N/A",
        Valor: order.value,
        "Quantidade de Cotas": order.qnt_quotas,
        Taxa: order.fee,
        "Status do Pagamento": this.getPaymentStatusText(order.payment_status),
        "Tipo de Pagamento": order.payment_type,
        Provedor: order.payment_provider,
        "Data de Criação": new Date(order.created_at).toLocaleDateString(
          "pt-BR"
        ),
        "Hora de Criação": new Date(order.created_at).toLocaleTimeString(
          "pt-BR"
        ),
        Cotas: order.quotas
          ? this.parseAndSortQuotas(order.quotas)
              .map((q) => this.formatQuota(q))
              .join(", ")
          : "N/A",
        "ID do Pedido": order.id,
        "ID da Campanha": order.id_campaing,
      }));

      // Criar workbook e worksheet
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(excelData);

      // Ajustar largura das colunas
      const colWidths = [
        { wch: 25 }, // Nome
        { wch: 18 }, // Telefone
        { wch: 25 }, // E-mail
        { wch: 12 }, // Valor
        { wch: 12 }, // Quantidade
        { wch: 12 }, // Taxa
        { wch: 15 }, // Status
        { wch: 15 }, // Tipo
        { wch: 12 }, // Provedor
        { wch: 12 }, // Data
        { wch: 12 }, // Hora
        { wch: 30 }, // Cotas
        { wch: 12 }, // ID Pedido
        { wch: 12 }, // ID Campanha
      ];

      ws["!cols"] = colWidths;

      // Adicionar worksheet ao workbook
      XLSX.utils.book_append_sheet(wb, ws, "Histórico de Pedidos");

      // Salvar arquivo
      const campaignName =
        this.raffles.find((r) => r.id == this.campaignSelected)?.name ||
        "Campanha";
      const fileName = `historico_pedidos_${campaignName.replace(
        /[^a-zA-Z0-9]/g,
        "_"
      )}_${new Date().toISOString().split("T")[0]}.xlsx`;

      XLSX.writeFile(wb, fileName);
    },
    async exportToCSV(data) {
      // Preparar dados para CSV
      const csvData = [
        // Cabeçalho
        [
          "Nome",
          "Telefone",
          "E-mail",
          "Valor",
          "Quantidade de Cotas",
          "Taxa",
          "Status do Pagamento",
          "Tipo de Pagamento",
          "Provedor",
          "Data de Criação",
          "Hora de Criação",
          "Cotas",
          "ID do Pedido",
          "ID da Campanha",
        ],
        // Dados
        ...data.map((order) => [
          order.name,
          getTelephone(order.phone),
          order.email || "N/A",
          order.value.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          }),
          order.qnt_quotas,
          order.fee.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          }),
          this.getPaymentStatusText(order.payment_status),
          order.payment_type,
          order.payment_provider,
          new Date(order.created_at).toLocaleDateString("pt-BR"),
          new Date(order.created_at).toLocaleTimeString("pt-BR"),
          order.quotas
            ? this.parseAndSortQuotas(order.quotas)
                .map((q) => this.formatQuota(q))
                .join(", ")
            : "N/A",
          order.id,
          order.id_campaing,
        ]),
      ];

      // Converter para string CSV
      const csvContent = csvData
        .map((row) => row.map((field) => `"${field}"`).join(","))
        .join("\n");

      // Criar e baixar arquivo
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");

      const campaignName =
        this.raffles.find((r) => r.id == this.campaignSelected)?.name ||
        "Campanha";
      const fileName = `historico_pedidos_${campaignName.replace(
        /[^a-zA-Z0-9]/g,
        "_"
      )}_${new Date().toISOString().split("T")[0]}.csv`;

      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>

<style scoped lang="scss">
.input-default {
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
}
.dark-mode-input {
  background-color: #1a2035 !important;
  border: 1px solid #10131f !important;
  color: #fff;
}
.orders .order-name {
  color: #16a34a;
  text-transform: uppercase;
  font-weight: 500;
  font-size: 0.96rem;
  letter-spacing: 0.05em;
}
.orders .order-infos span {
  font-size: 0.85rem;
}
.badge-green {
  display: inline-flex;
  align-items: center;
  border-radius: 0.375rem;
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity));
  padding: 0.1rem 0.3rem;
  text-transform: capitalize;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity));
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0
    var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0
    calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow),
    var(--tw-shadow, 0 0 #0000);
  --tw-ring-inset: inset;
  --tw-ring-color: rgb(22 163 74 / 0.2);
  border: 1pt solid #16a34a;
}

.badge-orange {
  display: inline-flex;
  align-items: center;
  border-radius: 0.375rem;
  --tw-bg-opacity: 1;
  background-color: rgb(253 236 234 / var(--tw-bg-opacity));
  padding: 0.1rem 0.3rem;
  text-transform: capitalize;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(231 166 41 / var(--tw-text-opacity));
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0
    var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0
    calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow),
    var(--tw-shadow, 0 0 #0000);
  --tw-ring-inset: inset;
  --tw-ring-color: rgba(226, 144, 50, 0.2);
  border: 1pt solid #e9a72e;
}

.badge-red {
  display: inline-flex;
  align-items: center;
  border-radius: 0.375rem;
  --tw-bg-opacity: 1;
  background-color: rgb(253 236 234 / var(--tw-bg-opacity));
  padding: 0.1rem 0.3rem;
  text-transform: capitalize;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity));
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0
    var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0
    calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow),
    var(--tw-shadow, 0 0 #0000);
  --tw-ring-inset: inset;
  --tw-ring-color: rgb(185 28 28 / 0.2);
  border: 1pt solid #b91c1c;
}

.badge-gray {
  display: inline-flex;
  align-items: center;
  border-radius: 0.375rem;
  --tw-bg-opacity: 1;
  background-color: rgb(230 230 230 / var(--tw-bg-opacity));
  padding: 0.1rem 0.3rem;
  text-transform: capitalize;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(73 73 73 / var(--tw-text-opacity));
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0
    var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0
    calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow),
    var(--tw-shadow, 0 0 #0000);
  --tw-ring-inset: inset;
  --tw-ring-color: rgb(185 28 28 / 0.2);
  border: 1pt solid #494949;
}

.size-5 {
  width: 1.25rem;
  height: 1.25rem;
}

.size-3 {
  width: 0.75rem;
  height: 0.75rem;
}

.options-button {
  float: right;
  border: 1px solid #7b809a;
  display: block;
  border-radius: 4px;
}

.options-list ul {
  list-style: none;
  padding: 0;
}

.options-list {
  display: none;
  position: absolute;
  right: 1.5rem;
  margin-top: 2rem;
  background-color: #fff;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  border-radius: 4px;
  z-index: 1;
}

.options-list ul li {
  padding: 5px;
  cursor: pointer;
  font-size: 0.85rem;
  font-weight: 300;
  text-transform: capitalize;
  color: #585b68;
}

.mr-1 {
  margin-right: 1px;
}

.mr-2 {
  margin-right: 2px;
}

.mr-3 {
  margin-right: 3px;
}

.mr-4 {
  margin-right: 4px;
}

.mr-5 {
  margin-right: 5px;
}

.mr-6 {
  margin-right: 6px;
}

.mr-7 {
  margin-right: 7px;
}

.mr-8 {
  margin-right: 8px;
}

.mr-9 {
  margin-right: 9px;
}

.mr-10 {
  margin-right: 10px;
}

.order-card {
  border-radius: 16px !important;
  background: #fff;
  box-shadow: none !important;
  border: 1px solid #585b682a;
}
.order-header {
  border-bottom: 1px solid #eaeaea;
  padding-bottom: 0.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  &-title {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
  }
}
.order-info span {
  display: block;
  margin: 4px 0;
  font-size: 0.9rem;
}
.quota-badge {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 5px;
  border: 1px solid #18813f;
  background: #f0fdf4;
  color: #18813f;
  font-size: 0.8rem;
  margin: 0.25rem 0.25rem 0 0;
}

.more-btn {
  background-color: transparent;
  border: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.no-data-message {
  text-align: center;
  font-size: 1.2rem;
  margin-top: 25px;
}

.export-button {
  font-size: 0.9rem !important;
  padding: 0.5rem 1rem !important;
  border-radius: 6px !important;
  font-weight: 600 !important;
}

.export-menu {
  z-index: 9999 !important;
}
</style>

<style lang="scss">
.campaign-select {
  margin-bottom: 0.5rem;
  display: flex;
  flex-direction: row;
  align-items: end;
  gap: 10px;

  .input-label {
    margin: 0 !important;
  }
}

.refresh-button {
  width: 160px !important;
}

@media screen and (max-width: 1000px) {
  .campaign-select {
    flex-direction: column;
  }

  .refresh-button {
    width: 100% !important;
    min-width: 160px;
  }
}
</style>